import React from 'react';

import { SvgIcon } from '@components/icon';
import {
  PointerImg,
  PointerInfoAnchor,
  PointerWrap,
} from '@components/map/location-marker.styled';
import { FlexListCustom, SmallText } from '@components/shared/common';
import { LocationPinProps } from '@models/common/map';

import LocationAddress from './location-address';

const LocationPin: React.FunctionComponent<LocationPinProps> = ({
  location,
  hideInfoPin,
}) => (
  <PointerWrap>
    {hideInfoPin ? null : (
      <PointerInfoAnchor
        target="_blank"
        rel="noreferrer"
        href={`http://www.google.com/maps/place/${Number(
          location.latitude,
        )},${Number(location.longitude)}/@${Number(location.latitude)},${
          location.longitude
        },14z`}
        css={{
          background: '#B5E8FF',
          transform: 'translate(-50%, -100%)',
          width: '240px',
          padding: '10px',
          textDecoration: 'none',
          display: 'block',
        }}
      >
        <FlexListCustom data-testid={`location-title-${location.name}`}>
          <SmallText fWeight="600" pr="5px">
            Brightside {location.name}
          </SmallText>
          <SvgIcon
            width="7"
            alt="Arrow Right Icon"
            src="right-arrow-thick.svg"
          />
        </FlexListCustom>
        <div
          data-testid={`location-address-${location.city}`}
          css={{ textAlign: 'left' }}
        >
          <LocationAddress location={location} smallText />
        </div>
      </PointerInfoAnchor>
    )}
    <PointerImg style={{ bottom: -10 }}>
      <SvgIcon width="58" src="location-marker.svg" alt="Location Marker" />
    </PointerImg>
  </PointerWrap>
);

export default LocationPin;
